<tpm-dialog-frame alt-theme [hasSticky]="true" [hasFooter]="false" [header]="'GLOSSARY_DIALOG.title' | translate">
  <div sticky class="sticky-container">
    <tpm-tabs variant="primary" [active]="activeTab()" [tabs]="tabs" (activeTabChange)="activeTab.set($event)"></tpm-tabs>
    <hr />
    <tpm-text-field
      class="search-field"
      name="search"
      [placeholder]="'GLOSSARY_DIALOG.searchPlaceholder' | translate"
      [icon]="'gpi-filled-search-alt'"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
    ></tpm-text-field>
    <div class="filters-container" [class.filters-container--scrollable]="isMobile()">
      <tpm-chip-set
        *ngIf="filters.length > 0"
        class="filters"
        [nowrap]="isMobile()"
        [huge]="isMobile()"
        [chips]="filters"
        [active]="activeFilters()"
        (selected)="activeFilters.set($event)"
      ></tpm-chip-set>
    </div>
    <button *ngIf="filters.length > 0" class="body-sm reset-filters-btn" (click)="activeFilters.set([])">
      {{ "GLOSSARY_DIALOG.resetFiltersBtn" | translate }}
    </button>
  </div>
  <ng-container *ngFor="let item of list(); let last = last">
    <div class="heading">
      <p class="h5 content-title" [class.content-title--full-width]="isMobile()">{{ item.title | translate }}</p>
      <div class="tags">
        <span *ngFor="let tag of item.tags; trackBy: trackByFn" class="body-xs tag-item">{{ tag }}</span>
      </div>
    </div>
    <p class="inner-html-content" [innerHTML]="item.content | translate"></p>
    <hr *ngIf="!last" />
  </ng-container>
</tpm-dialog-frame>
